import { ShieldAlert } from "lucide-react";

export default function DisclaimerBanner({ className = "" }) {
  return (
    <div
      data-testid="program-disclaimer-banner"
      className={`flex items-start gap-2 rounded-xl border border-amber-500/30 bg-amber-500/10 px-3 py-2.5 text-amber-200/90 ${className}`}
    >
      <ShieldAlert className="h-4 w-4 mt-0.5 shrink-0" />
      <p className="text-xs leading-relaxed">
        Programme bien-être général, ne remplace pas l'avis d'un professionnel de santé.
      </p>
    </div>
  );
}
